// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3OW1A","content":"content___2ktGp"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shop/Home/ShopHome/components/BuyAgainBar/index.modules.less
// module id = 1688
// module chunks = 367